define("powergen/transforms/point",
  [],
  function() {
    "use strict";
    var PointTransform;

    PointTransform = DS.Transform.extend({
      serialize: function(value) {
        return {
          x: value.get('x'),
          y: value.get('y')
        };
      },
      deserialize: function(value) {
        return this.get('store').createRecord('point', {
          x: value.x,
          y: value.y
        });
      }
    });


    return PointTransform;
  });